import React from "react";
import styles from "../../styles/chat.module.scss";
import { Space, Image } from "antd-mobile";

export default function ChatCreatContent(props: {
  handleClick: (tip: string) => void;
}) {
  const { handleClick } = props;
  const tipsList = [
    "https://github.com/WordPress/WordPress的5.0和6.0版本中对于编辑器功能有了什么升级？",
    "分析 https://github.com/vesoft-inc/nebula 中 Raft 算法的具体实现",
  ];
  return (
    <div className={styles.chatContent}>
      <div className={styles.gptsDiv}>
        <Image
          src="logo.png"
          alt="Product Logo"
          className={styles.productLogo}
        />
        <h2 className={styles.productTitle}>代码问题，就问Eagle</h2>
      </div>
      <div className={styles.intro}>
        Eagle
        能够帮你读懂整个项目的代码，请把你要解读的GitHub项目链接及相关问题告诉我吧，例如：
      </div>
      <div className={styles.chatTips}>
        {tipsList.map((item, index) => {
          return (
            <div
              key={index}
              className={styles.chatpdfTips}
              onClick={() => handleClick(item)}
            >
              <span className={styles.text}>{item}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
